import Component from 'vue-class-component'
import PreviewComponentVue from './PreviewComponent'
import { UrlData } from '../../store/editor/components/state'
import { LinkType, OembedLink } from '../dialog/UrlEditorInterface'
import ChamomileUrl from '../../misc/chamomile-url'
import { GetOembedResponse } from '../../api/iframely/core'

const MAX_DESCRIPTION_LENGTH = 90

@Component
export default class UrlVue extends PreviewComponentVue<UrlData> {

  get oembedLink(): OembedLink {
    return this.componentData.oembedLink
  }

  get linkType(): LinkType {
    return this.oembedLink.linkType
  }

  get url(): string {
    return this.oembedLink.url
  }

  get chamomileUrl(): ChamomileUrl {
    return new ChamomileUrl(this.url)
  }

  get domain(): string {
    return this.chamomileUrl.domain
  }

  get oembedResponse(): GetOembedResponse {
    return this.oembedLink.response
  }

  get fileName(): string {
    return this.chamomileUrl.decodedFileName
  }

  get title(): string {
    return this.oembedResponse.title || this.fileName
  }

  get description(): string {
    const description = this.oembedResponse.description || ''
    if (description.length > MAX_DESCRIPTION_LENGTH) {
      return description.substring(0, MAX_DESCRIPTION_LENGTH) + '...'
    }
    return description
  }

  get thumbnailUrl(): string {
    return this.oembedLink.thumbnail || ''
  }

  get html(): string {
    return this.oembedResponse.html || ''
  }
}
